import { ArrowUp, ArrowDown, ShoppingCart, ArrowCounterClockwise, AmazonLogo, Wallet, CreditCard, Package, CurrencyInr } from '@phosphor-icons/react';

export default function DashboardStatsGrid({ stats, formatCurrency }) {
  return (
    <>
      {/* Primary Stats */}
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
        <StatCard testId="stat-total-deposit" label="Total Deposit" icon={<ArrowUp size={20} className="text-green-500" />} value={formatCurrency(stats?.total_deposits)} valueClass="text-green-600" />
        <StatCard testId="stat-total-spend"   label="Total Spend"   icon={<ArrowDown size={20} className="text-red-500" />} value={formatCurrency(stats?.total_spend)} valueClass="text-red-600" />
        <StatCard testId="stat-balance"       label="Balance"       icon={<Wallet size={20} className="text-[#002FA7]" />} value={formatCurrency(stats?.balance)} />
        <StatCard testId="stat-card-balance"  label="Card Balance"  icon={<CreditCard size={20} className="text-[#002FA7]" />} value={formatCurrency(stats?.card_balance)} valueClass="text-[#002FA7]" />
        <StatCard testId="stat-amazon-balance" label="Amazon Balance" icon={<AmazonLogo size={20} className="text-[#FF9900]" />} value={formatCurrency(stats?.amazon_balance)} valueClass="text-[#FF9900]" />
      </div>

      {/* Secondary Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <StatCard testId="stat-bookings"  label="Total Bookings"  icon={<ShoppingCart size={20} className="text-[#002FA7]" />} value={stats?.booking_count || 0} />
        <StatCard testId="stat-quantity"  label="Total Cylinders" icon={<Package size={20} className="text-gray-600" />} value={stats?.total_quantity || 0} />
        <StatCard testId="stat-refunds"   label="Total Refunds"   icon={<ArrowCounterClockwise size={20} className="text-gray-500" />} value={formatCurrency(stats?.total_refunds)} />
        <StatCard testId="stat-convenience-fee" label="Convenience Fee Paid" icon={<CurrencyInr size={20} className="text-[#E90069]" />} value={formatCurrency(stats?.total_convenience_fee)} valueClass="text-[#E90069]" />
      </div>
    </>
  );
}

function StatCard({ testId, label, icon, value, valueClass = '' }) {
  return (
    <div className="stat-card" data-testid={testId}>
      <div className="flex items-center justify-between mb-2">
        <span className="stat-label">{label}</span>
        {icon}
      </div>
      <div className={`stat-value ${valueClass}`}>{value}</div>
    </div>
  );
}
